export default __webpack_public_path__ + "779c216b293650e7a4cf1b83eac7a3b7.pdf";